import { SEOHead } from '../components/seo/SEOHead';
import { useServices } from '../hooks/useServices';
import { ServiceCard } from '../components/service/ServiceCard';
import { Spinner } from '../components/ui/Card';

export default function ServicesListing() {
  const { services, isLoading, error } = useServices();

  return (
    <>
      <SEOHead
        title="All Services — Bharat Consultancy | Tax & Registration Services in Purulia"
        description="Browse all tax, GST, MSME, trade license, and registration services offered by Bharat Consultancy in Purulia, West Bengal."
        canonicalPath="/services"
      />

      <section className="bg-paper py-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="text-center">
            <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Our Services</p>
            <h1 className="mt-2 font-display text-4xl font-bold text-ink">Everything You Need, Filed Right</h1>
            <p className="mx-auto mt-3 max-w-xl text-ink/65">
              From GST registration to trademark filing — explore our full range of tax, compliance, and
              registration services.
            </p>
          </div>

          {isLoading && (
            <div className="mt-16 flex justify-center">
              <Spinner className="h-8 w-8 text-seal-blue" />
            </div>
          )}

          {error && (
            <p className="mt-10 text-center text-red-600">
              Couldn&apos;t load services right now. Please try again shortly.
            </p>
          )}

          {!isLoading && !error && (
            <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {services.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
